import ClubAddressAutocomplete from "../canchas/ClubAddressAutocomplete";
import ClubLocationPicker from "../canchas/ClubLocationPicker";

/**
 * Dirección + "Ubicación en el mapa" shared by EventForm and the guided event flow.
 * Same behavior as the Club "Ubicación" tab: typing an address by hand drops any
 * confirmed pin (coords are only valid for the address they were confirmed against),
 * while picking a suggestion or moving the pin sets lat/lng.
 *
 * `onChange` receives a partial patch ({ address } | { address, lat, lng } | { lat, lng }).
 * `locality` is the "Ciudad, Provincia" text appended to the geocoding query.
 */
const EventAddressMap = ({ address, lat, lng, locality = "", onChange }) => {
  const query = [address, locality].filter(Boolean).join(", ");
  return (
    <>
      <div className="ef-field">
        <label className="ef-label">Dirección</label>
        <ClubAddressAutocomplete
          value={address}
          onChange={(val) => onChange({ address: val, lat: "", lng: "" })}
          onPlaceSelected={({ address: a, lat: la, lng: ln }) => onChange({ address: a, lat: la, lng: ln })}
        />
      </div>
      <div className="ef-field">
        <label className="ef-label">Ubicación en el mapa</label>
        <p className="ef-hint">
          Buscamos la dirección automáticamente. Si el pin no cae en el lugar exacto, arrastralo o hacé clic en el mapa para corregirlo.
        </p>
        <div className="ef-map">
          <ClubLocationPicker
            address={query}
            lat={lat}
            lng={lng}
            entityLabel="evento"
            onChange={({ lat: la, lng: ln }) => onChange({ lat: la, lng: ln })}
          />
        </div>
      </div>
    </>
  );
};

export default EventAddressMap;
